<template>
    <div class="login">
        <form @submit.prevent.stop="send_new_email" class="field-container">
            <h1 class="t-c c-w">ESQUECI A SENHA</h1>
            <div class="label-group">
                <input type="email" :class="{filled: !$appUtils.isEmpty(entity.email)}" v-model="entity.email"/>
                <label>E-mail</label>
                <svg-icon icon="user"/>
            </div>

            <div class="error-message">
                <div :class="m.type" v-for="m in getForgetPassState.messages">{{m.msg}}</div>
            </div>

            <div class="t-c"><button :class="{rotate: getForgetPassState.running}" :disabled="getForgetPassState.running" type="submit">
                <span v-if="!getForgetPassState.running">ENVIAR NOVA SENHA</span>
                <span v-else><svg-icon icon="sync"/></span>
            </button></div>

            <div class="forgot-container t-c">
                <br/>
                <br/>
                <router-link to="login">VOLTAR</router-link>
            </div>
        </form>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex'
    const {mapActions, mapGetters} = createNamespacedHelpers('users');

    export default {
        name: "ForgotPassword",
        data() {
            return {
                entity: {}
            }
        },
        methods: {
            ...mapActions(['forgot', 'releaseState']),
            send_new_email(){
                this.forgot(this.entity.email);
            }
        },
        computed: {
            ...mapGetters(['getForgetPassState'])
        },
        mounted() {
            this.releaseState();
        },
        created() {
            this.entity = this.$appStorage.getUser() || {};
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/modules/session_control.scss";

    .login {
        .c-w {
            margin-bottom: 20%;
        }
        &:after {
            content: '';
            filter: grayscale(0%);
            background: radial-gradient(circle at bottom left, #52bc71 0%, #00566c 40%, #0e254c 100%);
            //background: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.1)), url(/assets/images/bg-trigo-1.jpg) no-repeat;
            background-size: cover;
        }
    }
</style>
